import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

export default function Navbar(props) {
  return (
    <>
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}> 
  <div className="container-fluid">
    <Link className="navbar-brand" to="/">{props.title}</Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link" aria-current="page" to="/">{props.Home}</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/about">{props.Link}</Link>
        </li>
      </ul>
      <div className={`form-check form-switch text-${props.mode==='light'? 'dark':'light'}`}>
              <input className="form-check-input" type="checkbox" onClick={props.toggleMode} role="switch" id="flexSwitchCheckDefault" />
              <label className="form-check-label" for="flexSwitchCheckDefault">Enable DarkMode</label>
            </div>
    </div>
  </div>
</nav>
    </>
  )
}

Navbar.prototype = {
    title: PropTypes.string.isRequired,  //Lazmi title Likhna Pary ga...
    home: PropTypes.string                // Na b Likhu to Kam Chal Jay ga...
  }
  
  Navbar.defaultProps = {
    title: 'Your Title Here',           //We should always set the default values of the props..
    Home: 'Your Home Info.',
  }
